import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import '@mdi/font/css/materialdesignicons.css'

Vue.use(Vuetify);

export default new Vuetify({

  theme: {
    dark: false,
    themes: {
      light: {
        background: 'white',
        primary: '#006394',
      },
    }
  },
  icons: {
    iconfont: 'mdiSvg',
  },
});
